"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncaVariableBase = void 0;
var types_1 = require("../types");
var constants_1 = require("./constants");
/**
 * IncaVariableBase is the base class which is extended by any class which acts
 * by applying an evaluator or reference onto a particular inca variable. Since functions
 * and/or references are defined with respect to a particular inca variable, this base class
 * therefore exposes the inca variable type and specific question (answer) specified by an
 * instance of such a class. See IncaVariableEval and IncaVariableReference for more information.
 */
var IncaVariableBase = /** @class */ (function () {
    function IncaVariableBase(question) {
        var _a, _b;
        this.question = question;
        var qType = question.type === types_1.QTYPES.POPUP
            ? ((_b = (_a = question === null || question === void 0 ? void 0 : question.popupCards) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type) || types_1.QTYPES.POPUP_CARD
            : question.type;
        this.incaVariable = this.getIncaVariableByQuestionType(qType);
    }
    IncaVariableBase.prototype.getIncaVariableByQuestionType = function (type) {
        return constants_1.IncaVariables.find(function (variable) {
            return variable.availableQTypes.includes(type);
        });
    };
    IncaVariableBase.prototype.getIncaVariable = function () {
        return this.incaVariable;
    };
    IncaVariableBase.prototype.getQuestion = function () {
        return this.question;
    };
    return IncaVariableBase;
}());
exports.IncaVariableBase = IncaVariableBase;
//# sourceMappingURL=IncaVariableBase.js.map